<template>
  <div>
    <van-popup
      :value="internalShow"
      @input="handlePopupChange"
      position="bottom"
      :style="{ height: '30%' }"
    >
      1212
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    value: {  // 遵守 v-model 约定
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internalShow: this.value  // 创建本地副本
    };
  },
  watch: {
    value(newVal) {  // 同步父级传入的变化
      this.internalShow = newVal;
    }
  },
  methods: {
    handlePopupChange(val) {  // 通知父级更新
      this.$emit('input', val);
    }
  }
};
</script>